import { render, staticRenderFns } from "./Exchange_rate_setting.vue?vue&type=template&id=01428cc1&scoped=true&"
import script from "./Exchange_rate_setting.vue?vue&type=script&lang=js&"
export * from "./Exchange_rate_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01428cc1",
  null
  
)

export default component.exports